"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>TravelerLineItems_ChildAgeSelect,
    ChildAgeSelect: ()=>ChildAgeSelect
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../../InputSelect/index.cjs");
const ageText = 'yrs';
const defaultText = 'Required';
function ChildAgeSelect({ index, isHotel = false, value, onChange }) {
    function handleChange(e) {
        onChange(index, e.target.value);
    }
    const options = selectOptions({
        isHotel
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: "my-2 flex w-full items-center justify-between",
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
            className: "flex w-full overflow-hidden text-ellipsis",
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.InputSelect, {
                size: "sm",
                isAutoWidth: true,
                selectMinWidth: 140,
                selectPadding: 20,
                name: `child-age-${index}`,
                defaultValue: value ?? options[0].value,
                "data-testid": "child-age-select",
                labelText: `Age of Child ${index + 1}`,
                "aria-label": `Select age for child ${index + 1}`,
                options: options,
                onChange: handleChange
            })
        })
    });
}
function selectOptions({ isHotel }) {
    const options = [
        {
            label: defaultText,
            value: ''
        }
    ];
    for(let i = 0; i <= 17; i++){
        let label = `${i} ${ageText}`;
        if (0 === i) label = isHotel ? 'Infant' : '0-1 Infant in lap';
        if (1 === i) label = isHotel ? '1 yr' : '0-1 Infant in seat';
        options.push({
            label,
            value: i + ''
        });
    }
    return options;
}
const TravelerLineItems_ChildAgeSelect = /*#__PURE__*/ (0, external_react_namespaceObject.memo)(ChildAgeSelect);
exports.ChildAgeSelect = __webpack_exports__.ChildAgeSelect;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "ChildAgeSelect",
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
